import React, { Component } from 'react'
import get from 'lodash/get'
import PropTypes from 'prop-types'
import { compose } from 'redux'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, withRouter } from 'react-router-dom'

import * as ROUTES from 'config/routes'
import { API_PENDING, API_SUCCESS, API_FAIL } from 'redux/api/constants'
import { Col, Row, Spinner } from 'elements'
import { formSubmit } from 'utils/form'
import { getZone, updateZone } from 'redux/modules/model/site'
import { zoneDetailsSelector, zoneDetailsStatusSelector } from 'redux/selectors'
import { ZoneForm } from 'smart-components'
import { PageContentTitle } from 'components'
import { withClientId } from 'hocs'
import './index.scss'


const COMPONENT_CSS_CLASSNAME = 'zone-edit'
const bemE = (suffix) => `${COMPONENT_CSS_CLASSNAME}__${suffix}`

class ZoneEdit extends Component {
  static propTypes = {
    clientId: PropTypes.string.isRequired,
    getZone: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    zone: PropTypes.object,
    zoneDetailsStatus: PropTypes.string.isRequired,
    updateZone: PropTypes.func.isRequired
  };

  componentDidMount() {
    const { clientId, getZone, match: { params: { siteId, zoneId, targetClientId } } } = this.props    
    getZone({ clientId,targetClientId, siteId, zoneId })
  }

  handleSubmit = (values) => {
    const { clientId, history, zone, updateZone } = this.props
    const siteId = get(zone, 'siteId');
    const zoneId = get(zone, 'zoneId');
    const targetClientId = get(zone, 'clientId');
    const changes = {
      description: values.description,
      name: values.name
    }
    return formSubmit(updateZone, { clientId,targetClientId, siteId, zoneId, changes })
      .then(() => history.push(ROUTES.ZONE))
  };

  render() {
    const { zone, zoneDetailsStatus } = this.props
    const initialValues = zone ? {
      ...zone
    } : null
    
    return (
      <Row>
        <Col xs={24} sm={12} md={10}>
          <p className={bemE('back')}><Link to={ROUTES.ZONE}>&laquo; Back</Link></p>
          <PageContentTitle>Edit a zone</PageContentTitle>
          {API_PENDING === zoneDetailsStatus && <Spinner />}
          {API_SUCCESS === zoneDetailsStatus && <ZoneForm initialValues={initialValues} onSubmit={this.handleSubmit} />}
          {API_FAIL === zoneDetailsStatus && <h2>Zone id is invalid</h2>}
        </Col>
      </Row>
    )
  }
}

export const selector = createStructuredSelector({
  zone: zoneDetailsSelector,
  zoneDetailsStatus: zoneDetailsStatusSelector
})

export const actions = {
  getZone,
  updateZone
}

export default compose(
  withRouter,
  withClientId,
  connect(selector, actions),
)(ZoneEdit)



// WEBPACK FOOTER //
// ./src/pages/zone/zone-edit/index.js